const features = [
	{
		icon: 'img/icons/feature-click-target.svg',
		description: 'Díky efektivnějšímu cílení a zasíláním notifikací v aplikaci',
		boldDesctiption: 'ušetříte náklady na marketing.',
	},
	{
		icon: 'img/icons/feature-alarm.svg',
		description:
			'Čtenost mailingu se u těch lepších pohybuje okolo jednotek procent.',
		boldDesctiption: 'Notifikace si čte více než 94 % lidí.',
	},
	{
		icon: 'img/icons/feature-contact.svg',
		description:
			'Veškeré informace a podklady mohou zákazníci najít ve vaší aplikaci.',
		boldDesctiption: 'Sjednoťte svou komunikaci.',
	},
	{
		icon: 'img/icons/feature-growth.svg',
		description: 'Přineste svým zákazníkům něco nového a držte se  trendů.',
		boldDesctiption: 'Aplikace vám otevře nové možnosti.',
	},
	{
		icon: 'img/icons/feature-analytic.svg',
		description:
			'Poznejte blíže své zákazníky. Aplikace  poskytuje detailnější',
		boldDesctiption: 'data o chování vašeho zákazníka.',
	},
	{
		icon: 'img/icons/feature-add-contact.svg',
		description:
			'Od každého zákazníka, který si stáhne aplikaci získáte nejen e-mail.',
		boldDesctiption: 'Rozšiřte si svou databázi zákazníku.',
	},
]
const GrowthFeatures = () => {
	return (
		<section className="my-24">
			<div className="mb-8 text-center sm:mb-16">
				<h2 className="mx-8 mb-4 text-center text-3xl font-bold sm:text-4xl">
					Posuňte váš e-shop o krok dál
				</h2>
				<p className="mx-4">
					Nakupování přes mobilní aplikace roste celosvětově až 3x rychleji než
					celá e-commerce.
				</p>
			</div>
			<div className="mx-8 flex flex-col gap-8 sm:gap-x-16 sm:gap-y-16 lg:mx-32 lg:grid lg:grid-cols-3 lg:grid-rows-2">
				{features.map(growthFeature => (
					<GrowthBox
						key={growthFeature.boldDesctiption}
						icon={growthFeature.icon}
						description={growthFeature.description}
						boldDesctiption={growthFeature.boldDesctiption}
					/>
				))}
			</div>
		</section>
	)
}

const GrowthBox = ({
	icon,
	description,
	boldDesctiption,
}: {
	icon: string
	description: string
	boldDesctiption: string
}) => {
	return (
		<div className="flex items-center gap-6 rounded-2xl bg-white p-8 shadow-custom">
			<img src={icon} alt={icon} width={64} height={64} />
			<p>
				{description} <span className=" font-bold">{boldDesctiption} </span>
			</p>
		</div>
	)
}
export default GrowthFeatures
